import { render, staticRenderFns } from "./UserFormDialog.vue?vue&type=template&id=23395d9e"
import script from "./UserFormDialog.vue?vue&type=script&lang=js"
export * from "./UserFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports